import { Icon } from '@graftcode/design-system'

import { NOTIFICATION_BADGE_VARIANT } from '../const/notification-badge-variant.const'
import { NOTIFICATION_TYPE } from '../const/notification-type.const'
import dataIcon from '../icons/data.svg'
import mailIcon from '../icons/mail.svg'
import megaphoneIcon from '../icons/megaphone.svg'
import plugIcon from '../icons/plug.svg'
import screwdriverIcon from '../icons/screwdriver.svg'
import shieldIcon from '../icons/shield.svg'
import type { NotificationIconConfig } from '../interfaces/notification-icon-config.interface'
import type { NotificationType } from '../types/notification-type.type'

const iconConfigByType: Record<NotificationType, NotificationIconConfig> = {
  [NOTIFICATION_TYPE.NEW_PACKAGE_VERSION]: {
    icon: Icon.BoxRegular,
    badge: NOTIFICATION_BADGE_VARIANT.INFO,
  },
  [NOTIFICATION_TYPE.DEPRECATED_PACKAGE]: {
    icon: Icon.BoxRegular,
    badge: NOTIFICATION_BADGE_VARIANT.WARNING,
  },
  [NOTIFICATION_TYPE.VULNERABILITY_DETECTED]: {
    customIcon: shieldIcon,
    badge: NOTIFICATION_BADGE_VARIANT.WARNING,
  },
  [NOTIFICATION_TYPE.HIGH_LATENCY_ALERT]: {
    icon: Icon.DSService,
    badge: NOTIFICATION_BADGE_VARIANT.WARNING,
  },
  [NOTIFICATION_TYPE.CONNECTION_ERROR]: {
    customIcon: plugIcon,
    badge: NOTIFICATION_BADGE_VARIANT.ERROR,
  },
  [NOTIFICATION_TYPE.SERVICE_DEGRADED]: {
    icon: Icon.DSService,
    badge: NOTIFICATION_BADGE_VARIANT.WARNING,
  },
  [NOTIFICATION_TYPE.SCHEDULED_MAINTENANCE]: {
    customIcon: screwdriverIcon,
  },
  [NOTIFICATION_TYPE.CRITICAL_VULNERABILITY]: {
    customIcon: shieldIcon,
    badge: NOTIFICATION_BADGE_VARIANT.ERROR,
  },
  [NOTIFICATION_TYPE.UNAUTHORIZED_LOGIN]: {
    customIcon: shieldIcon,
    badge: NOTIFICATION_BADGE_VARIANT.WARNING,
  },
  [NOTIFICATION_TYPE.CERTIFICATE_UPDATE]: {
    icon: Icon.LockClosedRegular,
    badge: NOTIFICATION_BADGE_VARIANT.WARNING,
  },
  [NOTIFICATION_TYPE.INVITED_TO_ORGANIZATION]: {
    customIcon: mailIcon,
    badge: NOTIFICATION_BADGE_VARIANT.INFO,
  },
  [NOTIFICATION_TYPE.ROLE_PERMISSION_CHANGE]: {
    icon: Icon.KeyRegular,
  },
  [NOTIFICATION_TYPE.NEW_FEATURE]: {
    customIcon: megaphoneIcon,
  },
  [NOTIFICATION_TYPE.SYSTEM_ANNOUNCEMENT]: {
    icon: Icon.ChannelRegular,
    badge: NOTIFICATION_BADGE_VARIANT.INFO,
  },
  [NOTIFICATION_TYPE.DAILY_DIGEST]: {
    icon: Icon.CalendarRegular,
  },
  [NOTIFICATION_TYPE.WEEKLY_REPORT]: {
    customIcon: dataIcon,
  },
}

export const getNotificationIconConfig = (type: NotificationType): NotificationIconConfig => iconConfigByType[type]
